const KEY = 'referrer'

export const referrerDetector = {
	capture: (referrer: null | string, redirectUrl: null | string) => {
		if (!('referrer' in localStorage)) {
			const endReferrer = referrer || document.referrer
			localStorage.setItem('referrer', endReferrer)
		}

		if (referrer) {
			if (referrer === 'web-store') {
				redirectUrl = 'https://snaily.io'
			}

			window.location.href = redirectUrl || 'https://snaily.io'
		}
	},

	get: () => localStorage.getItem(KEY)
}
